/**
 * This is fully customized page for payment
 * 
 * to create payment go with format like this
 * /*



item in cart
/*
     {
      "item_ref": "0001",Is this fixed format?
      "item_type": "product",
      "event_code": "BUY",
      "product_category_name": "Bracelet",
      "product_sub_category_name": "Gold Bracelet",
      "product_name": "Gold Bracelet 24 oz.",
      "product_sku": [
        "XXX-00001"
      ],
      "qty": 1,
      "charge_amount": 2000,
      "paid_amount": 2000,
      "discount_amount": 0,
      "product_category_id": "prdcat-83a58d27958907eb7952289f",
      "product_sub_category_id": "prdsct-83a58d27958907eb7952289f",
      "product_id": "prodct-600685de4e83e5020b956eed"
    },

 * 
 */

import * as React from "react";

import { Backdrop, Box, Grid, Popover, makeStyles } from "@material-ui/core";
import {
  loadPaymentGuestState,
  loadPaymentMemberState,
  removePaymentGuestState,
  removePaymentMemberState,
  savePaymentMemberState,
} from "../../../utils";
import { useContext, useEffect, useRef, useState } from "react";

import CartPanel from "../../../components/CartPanel";
import ClearAllDialog from "../../../components/ClearAllDialog";
import ClearItemDialog from "../../../components/ClearItemDialog";
import DiscountDialog from "../../../components/DiscountDialog";
import OffersDialog from "../../../components/OffersDialog";
import { PaymentCreateContext } from "./PaymentCreateContext";
import PointasCashDialog from "../../../components/PointasCashDialog";
import ProductSelector from "../../../components/ProductSelector";
import WalkinInfoDialog from "../../../components/WalkinInfoDialog";
import WalletPanel from "../../../components/WalletPanel";
import { useDataProvider } from "react-admin";
import { useHistory } from "react-router-dom";
import useSFAlert from "../../../hooks/useSFAlert";
import useWindowDimensions from "../../../hooks/useWindowDimensions";

//import { useAlert } from "react-hook-popup";

//import { loadState } from "../../../utils";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: "100%",
    height: "100%",
    backgroundColor: theme.layout.main.backgroundColor,
  },
  leftPanel: {
    display: "flex",
    backgroundColor: theme.layout.leftPanel.backgroundColor,
    zIndex: 0,
  },
  rightPanel: {
    width: "100%",
    paddingTop: 0,
    paddingLeft: 0,
    display: "flex",
    //justifyContent: "flex-end",
    justifyContent: "center",
    backgroundColor: theme.layout.rightPanel.backgroundColor,
    overflow: "auto",
    height: "100%",
    zIndex: 1,
  },
}));

const PaymentCreate = (props) => {
  const dataProvider = useDataProvider();
  const [loading, setLoading] = useState(true);
  const [, dispatch] = useContext(PaymentCreateContext);
  const history = useHistory();

  useEffect(() => {
    if (!history.location.state) {
      // return history.push("/payment");

      const [memberData, memberError] = loadPaymentMemberState();
      const [guestData, guestError] = loadPaymentGuestState();

      if (memberError || !memberData) {
        if (guestError || !guestData) {
          dispatch({
            type: "RESET_STATE",
          });
        } else {
          dispatch({
            type: "DO_NOTHING",
          });
        }
      } else {
        dispatch({
          type: "DO_NOTHING",
        });
      }
    } //Navigate to page normally
    else if (!history.location.state.member) {
      dispatch({
        type: "RESET_STATE",
      });
    } else {
      dispatch({
        type: "RESET_STATE",
      });
    }
    dataProvider
      .getList("product-categories", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "name", order: "ASC" },
        filter: { status: "Active" },
      })
      .then(({ data }) => {
        const cats = Object.entries(data).map(([, value]) => {
          return { name: value.name, id: value.id, selected: false };
        });
        dispatch({
          type: "SET_CATEGORIES",
          payload: cats,
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [dataProvider, dispatch]);
  if (loading) return null;

  return <PaymentCreateInside {...props} />;
  /**
   * <PaymentCreateContextProvider>
      <PaymentCreateInside {...props} />
    </PaymentCreateContextProvider>
   */
};

const PaymentCreateInside = (props) => {
  props = { basePath: "/products", ...props };
  const classes = useStyles();
  const [selectedCatIndex, setSelectedCatIndex] = useState(0);
  const [state, dispatch] = useContext(PaymentCreateContext);
  const { height } = useWindowDimensions();
  const history = useHistory();
  const rightPanelRef = useRef();
  const [alert] = useSFAlert();
  useEffect(() => {
    //In case refresh the page or press back button

    if (!history.location.state) {
      // return history.push("/payment");
      dispatch({
        type: "REMOVE_PAYMENT_CHANNEL",
      });
      const [memberData, memberError] = loadPaymentMemberState();
      const [guestData, guestError] = loadPaymentGuestState();
      if (memberError || !memberData) {
        if (guestError || !guestData) {
          dispatch({
            type: "SHOW_WALKIN",
            payload: null,
          });
        } else {
          dispatch({
            type: "HIDE_WALKIN",
            payload: null,
          });
          dispatch({
            type: "SET_GUEST",
            payload: guestData,
          });
        }
      } else {
        dispatch({
          type: "SET_MEMBER",
          payload: memberData,
        });
      }
      // Then check if stored previous payment
      // const [result, error] = loadPaymentState();
      // if (error || result === null || result === "")
      //   return history.push("/payment");
      // console.log(result);
      // console.log(JSON.parse(JSON.stringify(result)));
      // dispatch({
      //   type: "SET_STATE_FROM_STORAGE",
      //   payload: JSON.parse(JSON.stringify(result)),
      // });
    } //Navigate to page normally
    else if (!history.location.state.member) {
      removePaymentMemberState();
      dispatch({
        type: "SHOW_WALKIN",
        payload: null,
      });
    } else {
      removePaymentGuestState();
      savePaymentMemberState(history.location.state.member);
      dispatch({
        type: "SET_MEMBER",
        payload: history.location.state.member,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let rect = {};
  if (rightPanelRef.current)
    rect = rightPanelRef.current.getBoundingClientRect();
  return (
    <>
      <Grid container className={classes.allContainer}>
        <Grid item xs={12} sm={8} className={classes.leftPanel}>
          <ProductSelector
            selectedCatIndex={selectedCatIndex}
            setSelectedCatIndex={setSelectedCatIndex}
            {...props}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={4}
          className={classes.rightPanel}
          ref={rightPanelRef}
          style={{ height: height - 47 }}
        >
          {<CartPanel />}
        </Grid>
      </Grid>
      {state.showWallet ? (
        <Backdrop open={state.showWallet}>
          <Popover open={state.showWallet}>
            <WalletPanel top={rect.top} left={rect.left} />
          </Popover>
        </Backdrop>
      ) : null}
      <DiscountDialog onApply={() => null} />
      <OffersDialog alert={alert} />
      {state.showWalkinInfoDialog ? <WalkinInfoDialog /> : null}
      <ClearAllDialog
        open={state.showClearAll}
        onClose={() => dispatch({ type: "HIDE_CLEAR_ALL" })}
        onClearAll={() =>
          dispatch({
            type: "REMOVE_ALL",
          })
        }
      />
      <PointasCashDialog
        open={state.showPointasCash}
        onClose={() => dispatch({ type: "HIDE_POINT_AS_CASH" })}
      />
      <ClearItemDialog
        open={state.clearItemDialog?.show}
        onClose={() => dispatch({ type: "HIDE_CLEAR_ITEM" })}
        onClear={() =>
          dispatch({
            type: "REMOVE_PRODUCT_TO_ZERO",
            index: state.clearItemDialog?.index,
            // payload: state.clearItemDialog?.itemId,
          })
        }
        name={state.clearItemDialog?.itemName}
      />
    </>
  );
};

export default PaymentCreate;
